import styles from "./table-new.module.css"
import { NavLink, useParams } from "react-router-dom"
import { useCallback, useEffect, useState, useRef, useMemo } from "react"
import { useDispatch, useSelector } from "react-redux"
import Preloader from "../../preloader/preloader"
import { setIsLoading } from "../../../services/reducers/preloader-slice"
import { useActiveButton } from "../../../services/context/ActiveButtonContext"

// import { Table } from "antd";
import { DownOutlined } from "@ant-design/icons"
import { GetProp, RadioChangeEvent, TableProps } from "antd"
import { Form, Radio, Space, Switch, Table, ConfigProvider } from "antd"

// const {  DownOutlined  } = icons;
// const {  Form, Radio, Space, Switch, Table  } = antd;

const defaultExpandable = {
  expandedRowRender: (record) => <p>{record.description}</p>,
}
const defaultTitle = () => "Cюда можно добавить тайтл с описанием"

const defaultFooter = () => "Футер с описанием"

function TableNew() {
  const params = useParams()
  const valueContext = useActiveButton()
  const dispatch = useDispatch()
  const table = useSelector((store) => store.tables.tables)
  const isLoading = useSelector((store) => store.preloader.isLoading)
  const [promptToggle, setPromptToggle] = useState(
    localStorage.getItem("tablePromptToggle")
  )

  const [bordered, setBordered] = useState(false)
  const [loading, setLoading] = useState(false)
  const [size, setSize] = useState("large")
  const [expandable, setExpandable] = useState(defaultExpandable)
  const [showTitle, setShowTitle] = useState(false)
  const [showHeader, setShowHeader] = useState(true)
  const [showFooter, setShowFooter] = useState(true)
  // const [rowSelection, setRowSelection] = useState(false)
  // const [hasData, setHasData] = useState(true)
  const [tableLayout, setTableLayout] = useState()
  const [top, setTop] = useState("none")
  const [bottom, setBottom] = useState("bottomRight")
  const [ellipsis, setEllipsis] = useState(false)
  const [yScroll, setYScroll] = useState(false)
  const [xScroll, setXScroll] = useState("scroll")

  const handleBorderChange = (enable) => {
    setBordered(enable)
  }
  const handleLoadingChange = (enable) => {
    setLoading(enable)
  }

  const handleSizeChange = (e) => {
    setSize(e.target.value)
  }
  const handleTableLayoutChange = (e) => {
    setTableLayout(e.target.value)
  }
  const handleExpandChange = (enable) => {
    setExpandable(enable ? defaultExpandable : undefined)
  }
  const handleEllipsisChange = (enable) => {
    setEllipsis(enable)
  }
  const handleTitleChange = (enable) => {
    setShowTitle(enable)
  }
  const handleHeaderChange = (enable) => {
    setShowHeader(enable)
  }
  const handleFooterChange = (enable) => {
    setShowFooter(enable)
  }
  const handleRowSelectionChange = (enable) => {
    // setRowSelection(enable ? {} : undefined)
    // setRowSelection(false)
  }
  const handleYScrollChange = (enable) => {
    setYScroll(enable)
  }
  const handleXScrollChange = (e) => {
    setXScroll(e.target.value)
  }
  // const handleDataChange = (newHasData) => {
  //   setHasData(newHasData)
  // }
  const dataTitleKeys = useMemo(() => {
    return table.length
      ? Object.keys(table.filter((el) => "Earnings" in el)[0])
      : []
  }, [table])

  const dataTitleColumns = useMemo(() => {
    return dataTitleKeys.map((el, i) => {
      return {
        title: el,
        dataIndex: el,
      }
    })
  }, [dataTitleKeys])

  const dataRowsTable = useMemo(() => {
    const actualLengthView = table.filter((el) => "Earnings" in el)
    return actualLengthView.map((el, i) => {
      return {
        ...el,
        key: i,
      }
    })
  }, [dataTitleKeys])

  // console.log(dataRowsTable)

  // const columns = [
  //   {
  //     title: "Name",
  //     dataIndex: "name",
  //   },
  //   {
  //     title: "Age",
  //     dataIndex: "age",
  //     sorter: (a, b) => a.age - b.age,
  //   },
  //   {
  //     title: "Address",
  //     dataIndex: "address",
  //     filters: [
  //       {
  //         text: "London",
  //         value: "London",
  //       },
  //       {
  //         text: "New York",
  //         value: "New York",
  //       },
  //     ],
  //     onFilter: (value, record) => record.address.indexOf(value) === 0,
  //   },
  //   {
  //     title: "Action",
  //     key: "action",
  //     sorter: true,
  //     render: () => (
  //       <Space size="middle">
  //         <a>Delete</a>
  //         <a>
  //           <Space>
  //             More actions
  //             <DownOutlined />
  //           </Space>
  //         </a>
  //       </Space>
  //     ),
  //   },
  // ]

  // const data = []

  // for (let i = 1; i <= 30; i++) {
  //   data.push({
  //     key: i,
  //     name: "John Brown",
  //     age: Number(`${i}`),
  //     address: `New York No. ${i} Lake Park`,
  //     description: `My name is John Brown, I am ${i}2 years old, living in New York No. ${i} Lake Park.`,
  //   })
  // }

  const scroll = {}

  if (yScroll) {
    scroll.y = 1240
  }
  if (xScroll) {
    scroll.x = "100vw"
  }
  const tableColumns = dataTitleColumns.map((item) => ({
    ...item,
    ellipsis,
  }))

  if (xScroll === "fixed") {
    tableColumns[0].fixed = true
    // tableColumns[tableColumns.length - 1].fixed = "right"
  }

  const tableProps = {
    bordered,
    loading,
    size,
    // expandable,
    // title: showTitle ? defaultTitle : undefined,
    showHeader,
    // footer: showFooter ? defaultFooter : undefined,
    // rowSelection,
    scroll,
    tableLayout,
  }

  useEffect(() => {
    dispatch(setIsLoading(true))
    valueContext.getTableFromApi(params.sub, params.slug)
  }, [params.slug])

  const mounted = useRef(null)
  // useEffect(() => {
  //   if (mounted.current) {
  //     const checked = document.getElementsByClassName('ant-switch-inner-checked');
  //     for (let i = 0; i < checked.length; i++) {
  //       // checked[i].style.border = '2px solid blue';
  //       checked[i].style.background = 'red';
  //     }

  //   }
  //   console.log(mounted.current);

  // },[mounted.current])

  return (
    <>
      <div className={styles.headerContainer} />

      <section className={styles.section}>
        <div className={styles.navigationBox}>
          <NavLink to={"/"} className={styles.link}>
            <div className={styles.arrow}></div>
            Главная
          </NavLink>

          <NavLink to={"/tables"} className={styles.link}>
            <div className={styles.arrow}></div>
            Портфели
          </NavLink>
        </div>
      </section>

      {isLoading || table.length === 0 ? (
        <div className={styles.preloader}>
          <Preloader />
        </div>
      ) : (
        <div className={styles.main}>
          <h3 className={styles.mainTitle}>{table[0].name}</h3>

          <ConfigProvider
            theme={{
              token: {
                // Seed Token
                colorPrimary: "#172339",
                // colorPrimary: '#37D881',
                // borderRadius: 2,
                // colorLinkActive: "#172339",
                // Alias Token
                // colorBgContainer: '#f6ffed',
              },
            }}
          >
            <Form
              layout="inline"
              className="components-table-demo-control-bar"
              style={{
                marginBottom: 20,
                gap: "10px",
              }}
            >
              <Form.Item label="Границы">
                <Switch checked={bordered} onChange={handleBorderChange} />
              </Form.Item>
              {/*
            <Form.Item label="loading">
              <Switch checked={loading} onChange={handleLoadingChange} />
            </Form.Item>
            */}
              {/*
            <Form.Item label="Title">
              <Switch checked={showTitle} onChange={handleTitleChange} />
            </Form.Item>
            */}
              {/*
            <Form.Item label="Column Header">
              <Switch checked={showHeader} onChange={handleHeaderChange} />
            </Form.Item>
            */}
              {/*
              <Form.Item label="Footer">
                <Switch checked={showFooter} onChange={handleFooterChange} />
              </Form.Item>
              */}
                {/*
                <Form.Item label="Expandable">
                <Switch checked={!!expandable} onChange={handleExpandChange} />
              </Form.Item>
                */}
              {/*
            <Form.Item label="Checkbox">
              <Switch
                checked={!!rowSelection}
                onChange={handleRowSelectionChange}
              />
            </Form.Item>
            */}
              <Form.Item label="Фиксация заголовка">
                <Switch checked={!!yScroll} onChange={handleYScrollChange} />
              </Form.Item>
              {/*
            <Form.Item label="Has Data">
              <Switch checked={!!hasData} onChange={handleDataChange} />
            </Form.Item>
            */}
              <Form.Item label="Сократить">
                <Switch checked={!!ellipsis} onChange={handleEllipsisChange} />
              </Form.Item>
              <Form.Item label="Размер">
                <Radio.Group value={size} onChange={handleSizeChange}>
                  <Radio.Button value="large">Большой</Radio.Button>
                  <Radio.Button value="middle">Средний</Radio.Button>
                  <Radio.Button value="small">Маленький</Radio.Button>
                </Radio.Group>
              </Form.Item>
              <Form.Item label="Название">
                <Radio.Group value={xScroll} onChange={handleXScrollChange}>
                  <Radio.Button value="scroll">По умолчанию</Radio.Button>
                  <Radio.Button value="fixed">Фиксировать</Radio.Button>
                </Radio.Group>
              </Form.Item>
              <Form.Item label="Внутренний отступ">
                <Radio.Group
                  value={tableLayout}
                  onChange={handleTableLayoutChange}
                >
                  <Radio.Button value={undefined}>По умолчанию</Radio.Button>
                  <Radio.Button value="fixed">Увеличить</Radio.Button>
                </Radio.Group>
              </Form.Item>
              {/*
            <Form.Item label="Pagination Top">
              <Radio.Group
                value={top}
                onChange={(e) => {
                  setTop(e.target.value)
                }}
              >
                <Radio.Button value="topLeft">TopLeft</Radio.Button>
                <Radio.Button value="topCenter">TopCenter</Radio.Button>
                <Radio.Button value="topRight">TopRight</Radio.Button>
                <Radio.Button value="none">None</Radio.Button>
              </Radio.Group>
            </Form.Item>
            */}
              {/*
            <Form.Item label="Pagination Bottom">
              <Radio.Group
                value={bottom}
                onChange={(e) => {
                  setBottom(e.target.value)
                }}
              >
                <Radio.Button value="bottomLeft">BottomLeft</Radio.Button>
                <Radio.Button value="bottomCenter">BottomCenter</Radio.Button>
                <Radio.Button value="bottomRight">BottomRight</Radio.Button>
                <Radio.Button value="none">None</Radio.Button>
              </Radio.Group>
            </Form.Item>
            */}
            </Form>

            <Table
              {...tableProps}
              pagination={{
                position: [top, bottom],
                showSizeChanger: true,
              }}
              ref={mounted}
              columns={tableColumns}
              dataSource={dataRowsTable}
              scroll={scroll}
            />
          </ConfigProvider>
        </div>
      )}
    </>
  )
}

export default TableNew
